module.exports = __webpack_public_path__ + "static/media/university-tree-r.cf23ce4a.png";